import React from 'react'
import styled from 'styled-components'
import {isFetchBaseQueryError, isSerializedError} from '~/src/utils'

const StyledErrorBox = styled.div`
  color: var(--danger);
  font-size: var(--fs-caption);
  margin: var(--space-2) 0;
`

export default function ErrorBox({children: error}: {children: React.ReactNode}) {
  if (isFetchBaseQueryError(error)) {
    return (
      <StyledErrorBox data-testid="error-box">
        {JSON.stringify(error.data).replace(/"/g, '')}
      </StyledErrorBox>
    )
  }

  if (isSerializedError(error)) {
    return (
      <StyledErrorBox data-testid="error-box">
        {JSON.stringify(error.message).replace(/"/g, '')}
      </StyledErrorBox>
    )
  }

  if (typeof error === 'string') {
    return <StyledErrorBox data-testid="error-box">{error}</StyledErrorBox>
  }

  return null
}
